namespace Controlli {
    export namespace Area {
        export function Render(options: ChartOptions) {
            ChartsGlobal.RenderChart(options.DivIdValue, InitParams(options))
        }

        function InitParams(initOptions: ChartOptions): Object {
            let plotHeight = (initOptions.ChartHeight == null || initOptions.ChartHeight == 0 ? 400 : initOptions.ChartHeight);
            let showDataLabels = false;

            initOptions.Series.forEach((valore) => {
                valore.color = Utility.GetChartColor(valore.color);
            })

            let result = {
                series: initOptions.Series,
                chart: {
                    id: initOptions.ChartId,
                    height: plotHeight,
                    type: initOptions.Type,
                    toolbar: {
                        show: true,
                        tools: {
                            download: false,
                            selection: false,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: false,
                            reset: '<i class="fa-duotone fa-rotate-left fa-xl"></i>',
                            customIcons: []
                        }
                    }
                },
                dataLabels: {
                    enabled: showDataLabels,
                },
                stroke: {
                    curve: 'smooth'
                },
                legend: {
                    show: true,
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 5,
                    markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                    },
                    itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                    },
                },
                xaxis: {
                    categories: initOptions.Categories,
                },
            };
            return result;
        }

        //Contain the parameters for setting up the area chart
        export class ChartOptions extends ChartsGlobal.BaseChart {
            Categories: Array<string>;
            Series: Array<AreaSeries>
        }

        class AreaSeries {
            name: string
            data: object[]
            type: string
            color: string
        }
    }
}